/**
 * NovelMello 品牌 - Member 页面配置
 * 设计：浅渐变头部 + 钱包白卡（内嵌 VIP banner） + 4 行菜单白卡
 * 本站无登录功能、无登录入口：showLoginBtn 置 false，仅关闭渲染，登录逻辑代码保留
 * 菜单只有 4 项，无 Be a Writer
 */
import { memberCommonConfig } from './common'
import type { MemberPageConfig, MemberPageTexts } from './types'
import { t } from '@/i18n/utils'

export const theme = {
  // 头像圆底为纯白、无描边；保留字段以满足类型必填
  avatarBorder: '#FFFFFF',
  btnPrimaryBg: 'linear-gradient(90deg, #F0509B 0%, #9B5CF0 100%)',
  topUpBtnBg: 'linear-gradient(90deg, #F0509B 0%, #9B5CF0 100%)',
  vipBtnBg: 'linear-gradient(90deg, #F0509B 0%, #9B5CF0 100%)',
  // 头部浅渐变
  headerBg: 'linear-gradient(150deg, #FDE0EF 0%, #EDE4FD 100%)',
  // 卡内 VIP banner 浅渐变
  subscribeBg: 'linear-gradient(100deg, #FDE8F1 0%, #EDE4FD 100%)',
  subscribeText: '#2B1B34',
  subscribeText2: '#7C4DE8',
  // default 组件用的 VIP 背景图，本品牌不使用
  vipSubscribeBg: '',
  dividerColor: '#F2EAF4',
  cardShadow: '0 4px 16px rgba(124, 77, 232, 0.08)',
} as const

export const resources = {
  memberBg: '',
  userBg: '',
  // 游客头像用 lucide user 图标绘制，不使用图片
  userDefaultAvatar: '',
  memberVip: '/images/novelmello/member-vip.png',
  memberVipDiscount: '/images/novelmello/member-vip-discount.png',
} as const

/**
 * 文案：逐项委托给 memberCommonConfig 的 getter（保持懒取值，切换语言后仍能拿到最新翻译），
 * 仅覆盖 VIP 卡片标题/副标题两项。
 */
const texts: MemberPageTexts = {
  get signIn() { return memberCommonConfig.texts.signIn },
  get myWallet() { return memberCommonConfig.texts.myWallet },
  get coins() { return memberCommonConfig.texts.coins },
  get topUp() { return memberCommonConfig.texts.topUp },
  get get() { return memberCommonConfig.texts.get },
  get getVip() { return memberCommonConfig.texts.getVip },
  get vipMembership() { return memberCommonConfig.texts.vipMembership },
  get moreCoinsMoreBenefits() { return memberCommonConfig.texts.moreCoinsMoreBenefits },
  get expires() { return memberCommonConfig.texts.expires },
  get details() { return memberCommonConfig.texts.details },
  get transactionHistory() { return memberCommonConfig.texts.transactionHistory },
  get chaptersUnlocked() { return memberCommonConfig.texts.chaptersUnlocked },
  get contactUs() { return memberCommonConfig.texts.contactUs },
  get setting() { return memberCommonConfig.texts.setting },
  // 设计稿文案：Get VIP Membership / Unlimited reading of all stories
  get vipTitle() { return t('getVip') },
  get vipSubtitle() { return t('UnlimitedReadingAllStories') },
}

export const memberConfig: MemberPageConfig = {
  theme,
  resources,
  texts,
  // 本站无登录入口：不渲染 Sign In 按钮，登录逻辑保留
  showLoginBtn: false,
}
